import axios from '@_system/axios/axios.js'
export default {
	path: '/warehouse',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	pull(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/pull/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/warehouse.warehouse', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},
	goodsimport(id, data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/goodsimport/' + id, data, (res) => {
				resolve(res.data)
			})
		})
	},
	goodsexport(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/goodsexport', data, (res) => {
				resolve(res.data)
			})
		})
	},
}
